import React from "react";
import styled from "styled-components";
import { translate } from "../../../i18n";
import { connect } from "../../../redux";
import { getLocalParticipant, getSortedRemoteParticipantsByStatus, isParticipantModerator } from "../../function";
import ParticipantItem from "../ParticipantItem";
import "../../../../../assets/css/rightMenu.scss";

function ParticipantContent({
    text, 
    local, remote, isLocalHost, participantCnt, hover = true
}) {
    return (
        <div className="right_menu">
            { hover && <ParticipantItem isLocalHost={isLocalHost} participant={local} hover={hover} /> }

            <div className="item_content">
                { remote.map(p => {
                    if (!p) return null;
                    if (text && p.nickname.indexOf(text) === -1) return null;
                    return (
                        <ParticipantItem key={p.user_uuid} isLocalHost={isLocalHost} participant={p} hover={hover} />
                    );
                })}
            </div>
        </div> 
    )
}

function _mapStateToProps(state, ownProps) {
    const local = getLocalParticipant(state);
    const isLocalHost = local ? isParticipantModerator(state, local.user_uuid) : false;
    const remote = ownProps.participant ? ownProps.participant : getSortedRemoteParticipantsByStatus(state, false);
    const participantCnt = ownProps.participant ? ownProps.participant.length : remote.length;

    return {
        local,
        isLocalHost,
        remote,
        participantCnt
    }
}

export default translate(connect(_mapStateToProps)(ParticipantContent));
